import { makeAutoObservable, observable } from 'mobx';
import { AuthType } from '../types/auth.type';
import { StorageEnum } from '../enums/storage.enum';
import { getAuth } from './utils';
import { RootStore } from './root.store';

export class AuthStore {
  auth: AuthType | null = null;

  private _rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    makeAutoObservable(this, {
      auth: observable.ref
    });

    this.auth = getAuth();
  }

  setAuth(newAuth: AuthType): void {
    this.auth = newAuth;
    localStorage.setItem(StorageEnum.Token, newAuth.token);
  }

  clear(): void {
    this.auth = null;
    localStorage.removeItem(StorageEnum.Token);
    localStorage.removeItem(StorageEnum.TokenExpiration);
    this._rootStore.userStore.logOutUser();
  }
}
